/* @ngInject */
const sterileLabel = (
  wagonUtils
) => {
  const self = {}

  self.class = 'Stérile'
  self.title = 'Stériles'

  self.fields = {
    id: {
      text: 'Id',
    },
    name: {
      text: 'Nom',
    },
    weight: {
      text: 'Poids',
    },
  }

  self.statements = {
    number: (_index) => {
      return 'Stérile N°' + _index
    },
    titles: {
      edit: (_myWagonId) => {
        return 'Gestion des stériles de ' + wagonUtils.idToString(_myWagonId)
      },
    },
  }

  self.log = {
    search: {
      success: (_length = 0) => {
        if (_length === 0) {
          return 'Aucun stérile n\'a été trouvé.'
        } else if (_length === 1) {
          return '1 stérile a été trouvé.'
        } else {
          return _length + ' stériles ont été trouvés.'
        }
      },
      failure: 'Impossible de rechercher les stériles.',
    },
    save: {
      success: 'Le stérile a bien été enregistré.',
      failure: 'Impossible de sauvegarder cet stérile.',
    },
    update: {
      success: 'Le stérile a bien été modifié.',
      failure: 'Impossible de modifier cet stérile.',
    },
    delete: {
      success: 'Le stérile a bien été supprimé.',
      failure: 'Impossible de supprimer cet stérile.',
    },
    saveAll: {
      success: (_length = 0) => {
        if (_length === 0) {
          return 'Aucun stérile à sauvegarder.'
        } else if (_length === 1) {
          return 'Le stérile a bien été sauvegardé.'
        } else {
          return 'Les ' + _length + ' stériles ont été sauvegardés.'
        }
      },
      failure: 'Impossible de sauvegarder les essieux.',
    },
  }

  return self
}
export default sterileLabel



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/scrapping/sterile/resources/labels.resource.js